import type { ITypeQuestionProp } from "@Interface/patient";
import type { FormInstance } from "antd";

interface Props {
  dataForm?: FormInstance<any> | any;
  questionsForm?: ITypeQuestionProp | null;
}

const NoteForm = ({ questionsForm, dataForm }: Props) => {
  return (
    <div className="box container-box">
      <div className="card">
        <div className="card-header">Note</div>
        <div className="card-body">
          <div style={{ padding: 10 }}>
            <p>- Average false negative rate of mammography is 10-15%.</p>
            <p>
              - Management of a palpable abnormality must be based on clinical
              consideration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteForm;
